import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/image-preprocessor/after.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/image-preprocessor/before.png");
